<template>
  <div class="earthquake-page">
    <header-title
      title="الاستجابة للزلازل"
      titlePrevious="الرئيسية "
      color="var(--danger)"
    />

    <div>
      <swiper
        class="swiper-autoplay"
        :options="swiperOptions"
        :navigation="true"
        :dir="$store.state.appConfig.isRTL ? 'ltr' : 'rtl'"
        @transition-end="fun"
      >
        <swiper-slide style="" v-for="(slide, i) in slides" :key="i">

          <div
            :style="{
              'background-image': `url('${slide.img}')`,
            }"
            style="position: relative"
            class="bacg"
          >
            <div
              class="w-100"
              style="
                z-index: 2;
                opacity: 0.4;
                background-color: black;
                height: 600px;
                position: absolute;
              "
            ></div>
            <div style="z-index: 3; position: relative" class="title_des">
              <div>
                <h3 class="text-white">كارثة زلزال سوريا 2023</h3>
              </div>
                <p class="text-white b_slider">القلوب البيضاء تنثر خيرها وطيبها على المحتاجين بعد ما أصابتهم الكارثة بظلالها القاتمة، فكان لابد من مدِّ يد العون لهم
                  لتخفيف مَصابَ المتضررين من الزلزال ومساعدتهم على تخطِّي تداعيات الزلزال على حياتهم
                </p>
            </div>
          </div>
        </swiper-slide>
        <div slot="button-next" class="swiper-button-next text-white" />
        <div slot="button-prev" class="swiper-button-prev text-white" />
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
    </div>

    <div class="my-5 featured-container container">
      <EarthquakeFeaturedCard
        class="featured-card"
        v-for="(card, i) in featuredCards"
        :key="n"
        v-bind="card"
      />
    </div>
    <div class="container px-2">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1">الصحة</span>
    </div>
    <b-row class="my-3 mx-auto container">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="12"
        v-for="(card, i) in medCards"
        :key="i"
      >
        <EarthquakeStatisticCard v-bind="card" />
      </b-col>
    </b-row>
    <div class="container px-2">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1">الغذاء</span>
    </div>
    <b-row class="my-3 mx-auto container">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="12"
        v-for="(card, i) in foodCards"
        :key="i"
      >
        <EarthquakeStatisticCard v-bind="card" />
      </b-col>
    </b-row>
    <div class="container px-2">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1">السكن</span>
    </div>
    <b-row class="my-3 mx-auto container">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="12"
        v-for="(card, i) in resCards"
        :key="i"
      >
        <EarthquakeStatisticCard v-bind="card" />
      </b-col>
    </b-row>
    <div class="container px-2">
      <span class="py-50 px-1 bg-primary mr-1 title-radius"></span>
      <span class="h1">الدعم النفسي الإجتماعي</span>
    </div>
    <b-row class="my-3 mx-auto container">
      <b-col
        xl="4"
        lg="6"
        md="6"
        sm="12"
        v-for="(card, i) in mentalCards"
        :key="i"
      >
        <EarthquakeStatisticCard v-bind="card" />
      </b-col>
    </b-row>
    <div class="w-100 bg-warning py-4">
      <div class="container">
        <h4 class="container text-light">
          أرقام الحسابات المخصصة لاستجابة زلزال سوريا
        </h4>
        <div class="d-flex mt-2 pl-1">
          <div class="d-flex w-50 flex-column">
            <h6 class="text-light">
              الأمانة السورية للتنمية-حماة : 2050262888028
            </h6>
            <h6 class="text-light my-2">
              الأمانة السورية للتنمية-حلب : 2050262888007
            </h6>
            <h6 class="text-light">
              الأمانة السورية للتنمية-اللاذقية : 2050262888008
            </h6>
          </div>
          <div class="d-flex w-50 flex-column">
            <h6 class="text-light">حماة : 0943043603 - 0951333901</h6>
            <h6 class="text-light my-2">حلب : 0943043498 - 0951333884</h6>
            <h6 class="text-light">اللاذقية : 0943043543 - 0943043890</h6>
          </div>
        </div>
      </div>
      <b-row class="container">
        <b-col>
          <ul>
            <li></li>
          </ul>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import HeaderTitle from "../../components/HeaderTitle.vue";
import EarthquakeFeaturedCard from "../../components/EarthquakeFeaturedCard.vue";
import EarthquakeStatisticCard from "../../components/EarthquakeStatisticCard.vue";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { BImg, BRow, BCol } from "bootstrap-vue";
import "swiper/css/swiper.css";
// import { mapGetters } from 'vuex/types/helpers';

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
    BRow,
    BCol,
    HeaderTitle,
    EarthquakeFeaturedCard,
    EarthquakeStatisticCard,
  },
  data() {
    return {
      slides: [
        { img: require("./assets/slider/slide_1.jpg") },
          { img: require("./assets/slider/slide_2.jpg") },
          { img: require("./assets/slider/slide_3.jpg") },
          { img: require("./assets/slider/slide_4.jpg") },
          { img: require("./assets/slider/slide_5.jpg") },
      ],
      featuredCards: [
        {
          count: "3,034 طن",
          title: "",
          subtitle: "قوافل المساعدات",
          img: require("./assets/convoys.jpg"),
        },
        {
          count: "227 مليون",
          title: "ل.س",
          subtitle: "مساعدات مالية",
          img: require("./assets/Stacks of Syrian pounds.jpg"),
        },
      ],
      medCards: [
        {
          title: "سيارات الإسعاف وآليات النقل",
          rightNumber: "18",
          rightText: "آلية",
          leftNumber: "2",
          leftText: "المنظمات المساهمة",
          img: require("./assets/ambulance.jpg"),
        },
        {
          title: "الأجهزة الطبية",
          rightNumber: "2",
          rightText: "جهاز طبي",
          leftNumber: "1",
          leftText: "المنظمات المساهمة",
          img: require("./assets/medical-device.jpg"),
        },
        {
          title: "العيادات المتنقلة",
          rightNumber: "15",
          rightText: "عيادة",
          leftNumber: "2",
          leftText: "المنظمات المساهمة",
          img: require("./assets/clinic.jpg"),
        },
        {
          title: "المعاينة الطبية",
          rightNumber: "4,901",
          rightText: "مستفيد",
          leftNumber: "2",
          leftText: "المنظمات المساهمة",
          img: require("./assets/medical-attention.jpg"),
        },

        {
          title: "التكفل بنفقات العلاج",
          rightNumber: "",
          rightText:
            "كافة المتضررين نتيجة الكارثة بكافة المشافي الحكومية والخاصة وبكافة المحافظات",
          leftNumber: "1",
          leftText: "المنظمات المساهمة",
          img: require("./assets/expenses.jpg"),
        },
      ],
      foodCards: [
        {
          title: "السلل الغذائية المقدمة",
          rightNumber: "13,733",
          rightText: "سلة غذائية",
          leftNumber: "9",
          leftText: "المنظمات المساهمة",
          img: require("./assets/food-crates.jpg"),
        },
        {
          title: "المطابخ الميدانية",
          rightNumber: "11",
          rightText: "مطابخ",
          leftNumber: "9",
          leftText: "المنظمات المساهمة",
          img: require("./assets/kitchen.jpg"),
        },
        {
          title: "حليب الأطفال",
          rightNumber: "16,900 طن",
          rightText: "حليب أطفال",
          leftNumber: "6",
          leftText: "المنظمات المساهمة",
          img: require("./assets/baby_formula_shortage.jpg"),
        },
      ],
      resCards: [
        {
          title: "تكفل بتكاليف ايجار مسكن",
          rightNumber: "242",
          rightText: "بيت",
          leftNumber: "12",
          leftText: "المنظمات المساهمة",
          img: require("./assets/ebla-6.jpeg"),
        },
      ],
      mentalCards: [
        {
          title: "الدعم النفسي والاجتماعي",
          rightNumber: "60,000",
          rightText: "فرد",
          leftNumber: "4",
          leftText: "المنظمات المساهمة",
          img: require("./assets/therapist-main-1.jpg"),
        },
      ],
      statisticsCards: [
        // {
        //   title: "تخصيص حسابات للتبرعات المالية الخاصة بكارثة الزلزال",
        //   rightNumber: "3",
        //   rightText: "حساب",
        //   leftNumber: "1",
        //   leftText: "المنظمات المساهمة",
        //   img: require("./assets/Stacks of Syrian pounds.jpg"),
        // },
      ],
      swiperOptions: {
        loop: "true",
        Parallax: true,
        spaceBetween: 0,
        centeredSlides: true,
        speed: 900,
        effect: "fade",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
<style lang="scss">
.earthquake-page {
  .featured-container {
    display: flex;
    justify-content: space-around;
  }

  @media screen and (min-width: 300px) {
    .featured-container {
      flex-direction: column;
    }
    .featured-card {
      width: 100%;
    }
  }
  @media screen and (min-width: 1200px) {
    .featured-container {
      flex-direction: row;
    }
    .featured-card {
      width: 35%;
    }
  }
  .card {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  }
  .col-4 {
    padding: 2rem 1.5rem;
  }
  .card-img-top {
    object-fit: cover;
    height: 180px;
  }
  .title-radius {
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}
.bacg {
  z-index: 10;
  background-image: url("/images/slider/01.jpg");
  background-size: cover;
  background-position: 50% 50%;
  width: inherit;
  min-height: 500px;
  filter: grayscale(20%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  .title_des {
    width: 35%;
    margin-left: 70px;
  }
  .b_slider {
    margin-top: 20px;
    font-size: 20px;
    line-height: 25px;
    text-align: justify;
  }
}

@media (max-width: 550px) {
  .bacg {
    min-height: 300px;
    justify-content: flex-end;

    .title_des {
      width: 70%;
      margin-left: 70px;

      div {
        h3 {
          font-size: 18px;
        }
      }
    }
    .b_slider {
      font-size: 13px;
    }
  }
}
</style>
